import React from 'react';
import { TFunction } from 'i18next';
import { Select } from '../Select/Select';
import { SortColumnConfig, SortPanelConfig } from '../SortPanel/SortPanel.types';
import fundListOptions from './fundListOptions';
import { SortDirection } from './useSortState';

import useStyles from './FundList.style';

export interface SortConfig {
  key: string;
  direction: string;
}

export const createFundListSortConfig = (
  t: TFunction,
  requestSort: (name: string, direction?: SortDirection) => void,
  sortConfig: SortConfig,
  rateKey: string,
  handleSelectRateKey: (event: React.ChangeEvent<{ value: unknown }>) => void,
  classes: ReturnType<typeof useStyles>,
  purchaseProcessLayout: boolean = false,
  roiSelectAutoTestId?: string
): SortPanelConfig => {

  const nameColumn = {
      id: 'name',
      label: t('fund-list.sort-panel.name.column-name'),
      sortable: true,
      sortableInBothDirections: true,
      className: classes.sortName,
    }

  const fundTypeColumn = {
    id: 'fundType',
    label: t('fund-list.sort-panel.fundType.column-name'),
    sortable: true,
    sortableInBothDirections: true,
    className: classes.sortType,
    descendingFirstInSortPanel: true,
  }

  const riskColumn = {
    id: 'risk',
    label: t('fund-list.sort-panel.risk.column-name'),
    sortable: true,
    sortableInBothDirections: true,
    className: classes.sortRisk,
  };

  const pricingColumn = {
    id: 'pricing',
    label: t('fund-list.sort-panel.pricing.column-name'),
    sortable: true,
    sortableInBothDirections: true,
    className: classes.sortPricing,
    descendingFirstInSortPanel: true,
  };

  const horizonColumn = {
    id: 'horizon',
    label: t('fund-list.sort-panel.horizon.column-name'),
    sortable: true,
    sortableInBothDirections: true,
    className: classes.sortPricing,
  }

  const roiColumn: SortColumnConfig = {
    id: 'roi',
    label: t('fund-list.sort-panel.roi.column-name'),
    sortable: true,
    sortableInBothDirections: true,
    className: classes.sortChart,
    additionalElement: React.createElement(Select, {
      className: 'roiSelect',
      labelId: 'fund-chart-id',
      value: rateKey,
      onChange: handleSelectRateKey,
      options: fundListOptions.roi,
      autoTestId: roiSelectAutoTestId,
    }),
    descendingFirstInSortPanel: true,
  }

  const columns = [roiColumn, riskColumn, horizonColumn,
    ...(!purchaseProcessLayout ? [fundTypeColumn] : []), pricingColumn, nameColumn];

  return {
    columns,
    roiColumn,
    currentSort: {
      field: sortConfig.key,
      direction: sortConfig.direction as 'asc' | 'desc',
    },
    onSort: requestSort,
    className: classes.sortPanel,
  };
};
